import(/* webpackMode: "eager" */ "/build/4b196749-84e3-46eb-ba1e-3337a7582b6f/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/4b196749-84e3-46eb-ba1e-3337a7582b6f/node_modules/react-wavify/lib/index.module.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/4b196749-84e3-46eb-ba1e-3337a7582b6f/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/build/4b196749-84e3-46eb-ba1e-3337a7582b6f/src/design-system/buttons/ButtonLink.tsx");
;
import(/* webpackMode: "eager" */ "/build/4b196749-84e3-46eb-ba1e-3337a7582b6f/src/design-system/layout/Main.tsx");
